
import Vue from "vue";

export default Vue.extend({
  name: "dashboard-alert",
  props: {
        alertType: String,
        alertMessage: String
    },
    methods: {
        setAlertBg: function (alertType) {
            if (alertType === "URGENT") {
                return "background-color:#f44336";
            }
            else if (alertType === "UPDATE") {
                return "background-color: #ab47bc";
            }
            return '';
        }
    }
});
